/* Fragrance Hub – Proben pro Gramm (6–15 g)
   Varianten, deren Titel "pro Gramm" enthält (jede Probe = eigenes Fläschchen/eigene Zeile), werden pro Gramm verkauft:
   Mengenfeld = Gramm, Minimum 6, Maximum 15.
   Angezeigt wird immer der Gesamtpreis (6 g = Startpreis, jedes weitere Gramm wird addiert). */
(function () {
  var MIN = 6, MAX = 15;
  var LG = (document.documentElement.lang || 'de').slice(0, 2);
  var DICT = {
    de: { label: 'Gramm je Fläschchen (6–15 g)', bottles: 'Anzahl Fläschchen', probe: 'Probe', more: 'jedes weitere Gramm', perBottle: 'je Fläschchen',
          sel: 'Ihre Auswahl', fill: 'Füllmenge', one: '1 Fläschchen', freeLeft: function (x) { return 'Noch ' + x + ' bis zum kostenlosen Versand innerhalb Deutschlands'; },
          free: '✓ Kostenloser Versand innerhalb Deutschlands', net: 'Alle Preise netto zzgl. MwSt. · Versand bis 12 Uhr am selben Werktag',
          added: '✓ Zum Warenkorb hinzugefügt', toCart: 'Zum Warenkorb & zur Kasse', toCartInfo: 'Im Warenkorb: USt-IdNr., Bestellreferenz und Hinweise zur Bestellung angeben.' },
    en: { label: 'Grams per bottle (6–15 g)', bottles: 'Number of bottles', probe: 'Sample', more: 'each extra gram', perBottle: 'per bottle',
          sel: 'Your selection', fill: 'Fill quantity', one: '1 bottle', freeLeft: function (x) { return x + ' left for free shipping within Germany'; },
          free: '✓ Free shipping within Germany', net: 'All prices net plus VAT · Orders by 12 noon ship the same working day',
          added: '✓ Added to cart', toCart: 'Go to cart & checkout', toCartInfo: 'In the cart: enter VAT ID, order reference and order notes.' },
    ar: { label: 'الغرامات لكل عبوة (6–15 غ)', bottles: 'عدد العبوات', probe: 'عينة', more: 'كل غرام إضافي', perBottle: 'لكل عبوة',
          sel: 'اختيارك', fill: 'الكمية', one: 'عبوة واحدة', freeLeft: function (x) { return 'باقي ' + x + ' للشحن المجاني داخل ألمانيا'; },
          free: '✓ شحن مجاني داخل ألمانيا', net: 'جميع الأسعار صافية بدون ضريبة · الطلب قبل 12 ظهرًا يُشحن في نفس يوم العمل',
          added: '✓ تمت الإضافة إلى السلة', toCart: 'إلى السلة والدفع', toCartInfo: 'في السلة: الرقم الضريبي ومرجع الطلب والملاحظات.' }
  };
  var T = DICT[LG] || DICT.de;
  var LABEL = T.label;
  var PRICES = window.FH_GRAMM || {};            /* { variantId: Cent pro Gramm } */
  var ids = new Set(Object.keys(PRICES));
  var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

  function isGram(id) { return ids.has(String(id)); }
  /* Probe-Auswahl auch ohne Preisliste erkennen (z.B. Schnellkauf-Fenster auf Kollektionsseiten) */
  function gramSelected(el) {
    var root = el.closest('quick-add-modal, product-info, .shopify-section, section') || document;
    var r = root.querySelector('input[type=radio]:checked');
    var all = root.querySelectorAll('input[type=radio]:checked, select option:checked');
    for (var i = 0; i < all.length; i++) if (/pro\s*gramm|per\s*gram|بالغرام/i.test(all[i].value || '')) return true;
    return false;
  }
  function gramForm(f, idInput) { return isGram(idInput.value) || gramSelected(f); }
  function attr(el, a, v) {
    if (v === null) { if (el.hasAttribute(a)) el.removeAttribute(a); }
    else if (el.getAttribute(a) !== String(v)) el.setAttribute(a, String(v));
  }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  /* ---------- Produktseite ---------- */
  function applyProduct() {
    var idInputs = document.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
    idInputs.forEach(function (idInput) {
      var root = idInput.closest('product-info') || idInput.closest('section') || document;
      var qty = root.querySelector('input.quantity__input[name="quantity"]');
      if (!qty) return;
      var gram = gramForm(idInput.form || idInput, idInput);
      var label = root.querySelector('label[for="' + qty.id + '"]');
      var wrap = qty.closest('quantity-input') || qty.parentNode;
      var hint = root.querySelector('.fh-gram-hint');
      var price = root.querySelector('.price__regular .price-item--regular, .price .price-item--regular');

      if (gram) {
        if (!qty.dataset.fhGram) {
          qty.dataset.fhGram = '1';
          if (label && !label.dataset.fhOrig) label.dataset.fhOrig = label.textContent;
        }
        attr(qty, 'min', MIN); attr(qty, 'max', MAX); attr(qty, 'step', 1);
        attr(qty, 'data-min', MIN); attr(qty, 'data-max', MAX);
        var v = parseInt(qty.value, 10) || 0;
        if (v < MIN || v > MAX) {
          v = v < MIN ? MIN : MAX;
          qty.value = v;
          qty.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (label) setText(label, LABEL);

        var cent = PRICES[String(idInput.value)] || 0;
        if (!hint && wrap && wrap.parentNode) {
          hint = document.createElement('p');
          hint.className = 'fh-gram-hint';
          hint.style.cssText = 'font-size:1.3rem;color:#5b5a57;margin:.6rem 0 0;line-height:1.5;';
          wrap.parentNode.insertBefore(hint, wrap.nextSibling);
        }
        var box = bottleBox(root, wrap);
        var n = box ? (parseInt(box.dataset.n, 10) || 1) : 1;
        if (price && cent) setText(price, fmt.format(cent * v * n / 100));
        if (hint && cent) {
          setText(hint, T.probe + ' ' + MIN + ' g = ' + fmt.format(cent * MIN / 100) +
            ' · ' + T.more + ' + ' + fmt.format(cent / 100) + ' (max. ' + MAX + ' g ' + T.perBottle + '). ' +
            T.sel + ': ' + (n > 1 ? n + ' × ' : '') + v + ' g = ' + fmt.format(cent * v * n / 100));
        }
      } else if (qty.dataset.fhGram) {
        delete qty.dataset.fhGram;
        attr(qty, 'min', 1); attr(qty, 'max', null); attr(qty, 'data-min', 1); attr(qty, 'data-max', null);
        qty.value = 1;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
        if (label && label.dataset.fhOrig) label.textContent = label.dataset.fhOrig;
        if (hint) hint.remove();
        var bx = root.querySelector('.fh-bottles'); if (bx) bx.remove();
      }
    });
  }

  /* Jedes Fläschchen = eigene Warenkorb-Zeile. Auf der Produktseite: Gramm je Fläschchen (Mengenfeld)
     + Anzahl Fläschchen (eigener Zähler). Beim Hinzufügen werden n getrennte Zeilen angelegt. */
  var pendingAdd = null;
  function bottleBox(root, wrap) {
    var box = root.querySelector('.fh-bottles');
    if (box || !wrap || !wrap.parentNode) return box;
    box = document.createElement('div');
    box.className = 'fh-bottles';
    box.dataset.n = '1';
    box.style.cssText = 'display:flex;align-items:center;gap:1rem;margin:1rem 0 0;font-size:1.4rem;color:#1c2135;';
    box.innerHTML = '<span>' + T.bottles + '</span>' +
      '<span style="display:inline-flex;align-items:center;border:1px solid rgba(28,33,53,.35);border-radius:6px">' +
      '<button type="button" data-d="-1" style="width:3.6rem;height:3.6rem;border:0;background:none;font-size:1.8rem;cursor:pointer">−</button>' +
      '<span class="fh-bn" style="min-width:2.6rem;text-align:center;font-weight:600">1</span>' +
      '<button type="button" data-d="1" style="width:3.6rem;height:3.6rem;border:0;background:none;font-size:1.8rem;cursor:pointer">+</button></span>';
    box.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-d]'); if (!b) return;
      var n = Math.min(10, Math.max(1, (parseInt(box.dataset.n, 10) || 1) + Number(b.dataset.d)));
      box.dataset.n = String(n);
      box.querySelector('.fh-bn').textContent = n;
      run();
    });
    var hint = root.querySelector('.fh-gram-hint');
    (hint || wrap).parentNode.insertBefore(box, (hint || wrap).nextSibling);
    return box;
  }
  function markForms() {}
  /* beim Klick auf "In den Warenkorb" merken: wie viele Fläschchen mit wie viel Gramm */
  document.addEventListener('submit', function (e) {
    var f = e.target, idInput = f && f.querySelector && f.querySelector('input[name="id"]');
    if (!idInput || !gramForm(f, idInput)) { pendingAdd = null; return; }
    var root = f.closest('product-info') || f.closest('section') || document;
    var qty = root.querySelector('input.quantity__input[name="quantity"]');
    var box = root.querySelector('.fh-bottles');
    var g = Math.min(MAX, Math.max(MIN, parseInt(qty && qty.value, 10) || MIN));
    pendingAdd = { id: idInput.value, g: g, n: box ? (parseInt(box.dataset.n, 10) || 1) : 1, at: Date.now() };
  }, true);
  /* Warenkorb-Anfrage des Themes umschreiben: n getrennte Zeilen mit eigener Kennung */
  var origFetch = window.fetch;
  window.fetch = function (url, cfg) {
    try {
      var u = String(url && url.url || url);
      if (pendingAdd && /\/cart\/add/.test(u) && cfg && cfg.body instanceof FormData &&
          String(cfg.body.get('id')) === String(pendingAdd.id) && Date.now() - pendingAdd.at < 5000) {
        var p = pendingAdd; pendingAdd = null;
        var items = [], stamp = String(Date.now());
        for (var i = 0; i < p.n; i++) items.push({ id: Number(p.id), quantity: p.g, properties: { _Flasche: stamp + '-' + i } });
        var body = { items: items };
        if (cfg.body.get('sections')) body.sections = String(cfg.body.get('sections'));
        if (cfg.body.get('sections_url')) body.sections_url = String(cfg.body.get('sections_url'));
        var headers = Object.assign({}, cfg.headers || {}, { 'Content-Type': 'application/json', Accept: 'application/json' });
        cfg = Object.assign({}, cfg, { body: JSON.stringify(body), headers: headers });
        url = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js';
      }
    } catch (e) {}
    return origFetch.apply(this, [url, cfg]);
  };

  /* ---------- Warenkorb (Seite + Drawer) ---------- */
  function applyCartInputs() {
    ids.forEach(function (id) {
      document.querySelectorAll('input.quantity__input[data-quantity-variant-id="' + id + '"]').forEach(function (q) {
        attr(q, 'min', MIN); attr(q, 'max', MAX); attr(q, 'data-min', MIN); attr(q, 'data-max', MAX);
        var item = q.closest('.cart-item, tr, li') || q.parentNode;
        var details = item.querySelector('.cart-item__details, .cart-drawer__item-details') || item;
        var g = parseInt(q.value, 10) || 0;
        var line = details.querySelector('.fh-gram-line');
        if (!line) {
          line = document.createElement('p');
          line.className = 'fh-gram-line';
          line.style.cssText = 'margin:.4rem 0 0;font-weight:600;color:#1c2135;font-size:1.4rem;';
          details.appendChild(line);
        }
        var cent = PRICES[String(id)];
        setText(line, T.fill + ': ' + g + ' g (' + T.one + ')' + (cent ? ' · ' + fmt.format(cent / 100) + ' / g' : ''));
        var w = q.closest('quantity-input');
        if (w && !w.parentNode.querySelector('.fh-g-unit')) {
          var u = document.createElement('span');
          u.className = 'fh-g-unit';
          u.textContent = 'g';
          u.style.cssText = 'margin-inline-start:.6rem;font-weight:600;align-self:center;';
          w.parentNode.insertBefore(u, w.nextSibling);
        }
      });
    });
  }

  /* ---------- Warenkorb-Seitenleiste (Drawer): Versand-Fortschritt + Bestätigung ---------- */
  var lastCart = null, addedAt = 0, FREE = 15000;
  function decorateDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d || !lastCart) return;
    var foot = d.querySelector('.drawer__footer');
    if (foot) {
      var box = foot.querySelector('.fh-ship');
      if (!box) {
        box = document.createElement('div');
        box.className = 'fh-ship';
        box.style.cssText = 'margin:0 0 1.2rem;padding:1.2rem 1.4rem;border-radius:8px;background:#1f2433;color:#fff;font-size:1.3rem;line-height:1.4;';
        box.innerHTML = '<div class="fh-ship-t"></div><div style="height:4px;margin-top:.8rem;border-radius:2px;background:rgba(255,255,255,.18)"><div class="fh-ship-b" style="height:100%;border-radius:2px;background:#d9bf7a;width:0"></div></div>';
        foot.insertBefore(box, foot.firstChild);
      }
      var rest = FREE - (lastCart.total_price || 0);
      setText(box.querySelector('.fh-ship-t'), rest > 0
        ? T.freeLeft(fmt.format(rest / 100))
        : T.free);
      var w = Math.min(100, Math.round((lastCart.total_price || 0) / FREE * 100)) + '%';
      var bar = box.querySelector('.fh-ship-b'); if (bar.style.width !== w) bar.style.width = w;
      var net = foot.querySelector('.fh-net');
      if (!net) {
        net = document.createElement('p');
        net.className = 'fh-net';
        net.style.cssText = 'margin:.4rem 0 0;font-size:1.2rem;color:#6b6a66;';
        net.textContent = T.net;
        var tot = foot.querySelector('.totals'); (tot || foot).appendChild(net);
      }
    }
    /* Kasse über die Warenkorb-Seite: dort USt-IdNr. (Reverse Charge), Bestellreferenz und Hinweise */
    var co = d.querySelector('[name="checkout"]');
    if (co && !d.querySelector('.fh-to-cart')) {
      co.style.display = 'none';
      var a = document.createElement('a');
      a.className = 'button button--primary button--full-width fh-to-cart';
      a.href = (window.routes && routes.cart_url) || '/cart';
      a.textContent = T.toCart;
      var info = document.createElement('p');
      info.className = 'fh-to-cart-info';
      info.style.cssText = 'margin:.8rem 0 0;font-size:1.2rem;color:#6b6a66;text-align:center;';
      info.textContent = T.toCartInfo;
      co.parentNode.insertBefore(a, co);
      co.parentNode.insertBefore(info, co);
    }
    var head = d.querySelector('.drawer__header');
    if (head) {
      var ok = head.querySelector('.fh-added');
      var show = Date.now() - addedAt < 6000;
      if (show && !ok) {
        ok = document.createElement('p');
        ok.className = 'fh-added';
        ok.style.cssText = 'margin:.6rem 0 0;padding:.6rem 1rem;border-radius:6px;background:#eef7f1;color:#1e6b41;font-size:1.3rem;font-weight:600;';
        ok.textContent = T.added;
        head.appendChild(ok);
        setTimeout(function () { var x = d.querySelector('.fh-added'); if (x) x.remove(); }, 6000);
      }
    }
  }

  var checking = false;
  function checkCart() {
    if (checking) return;
    checking = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        lastCart = cart; decorateDrawer();
        var fixes = [];
        (cart.items || []).forEach(function (it) {
          if (!/-1G$/i.test(it.sku || '')) return;
          ids.add(String(it.variant_id));
          if (!PRICES[String(it.variant_id)]) PRICES[String(it.variant_id)] = it.price;
          if (it.quantity < MIN) fixes.push({ change: { id: it.key, quantity: MIN } });
          else if (it.quantity > MAX) {
            /* zusammengelegte Proben (z.B. 2 × 20 g = 40) wieder in einzelne Fläschchen aufteilen */
            fixes.push({ change: { id: it.key, quantity: MAX } });
            var rest = it.quantity - MAX, n = 0;
            while (rest > 0) {
              var chunk = Math.min(MAX, Math.max(MIN, rest));
              fixes.push({ add: { items: [{ id: it.variant_id, quantity: chunk,
                properties: { _Flasche: String(Date.now()) + '-' + (n++) } }] } });
              rest -= chunk;
            }
          }
        });
        applyCartInputs();
        if (!fixes.length) return;
        return fixes.reduce(function (p, f) {
          return p.then(function () {
            return fetch(f.change ? '/cart/change.js' : '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(f.change || f.add)
            });
          });
        }, Promise.resolve()).then(function () { location.reload(); });
      })
      .catch(function () {})
      .then(function () { checking = false; });
  }

  /* ---------- Start ---------- */
  var t;
  function run() { clearTimeout(t); t = setTimeout(function () { applyProduct(); markForms(); applyCartInputs(); decorateDrawer(); }, 60); }

  document.addEventListener('DOMContentLoaded', function () {
    run();
    checkCart();
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
    ['change', 'input', 'click'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        var el = e.target;
        if (el && el.closest && (el.closest('quantity-input') || (el.matches && el.matches('input[name="id"], variant-selects input, variant-selects select')))) run();
      });
    });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) { if (ev && ev.source === 'product-form') addedAt = Date.now(); setTimeout(checkCart, 300); });
      if (PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, run);
    }
  });
})();
